export const CONTENT_DEFAULTS = {
  site_tagline: "Ghar jaisa swad, dil se banaa",
  header_pincode_badge: "Kalkaji · 110019",
  header_preorder_badge: "Order 24 hrs ahead",
  hero_badge: "Kalkaji, New Delhi only",
  hero_title_1: "Slow-cooked desi flavours,",
  hero_title_highlight: "pre-ordered",
  hero_title_2: "for tomorrow.",
  hero_subtitle:
    "Desi Karchi cooks fresh against your order — never reheated, never rushed. Pick your dishes, choose a delivery slot at least 24 hours ahead, and we bring the kadhai to your doorstep in Kalkaji 110019.",
  pincode_widget_title: "Do we deliver to you?",
  pincode_widget_text: "We currently serve only pincode 110019 (Kalkaji).",
  menu_kicker: "Fresh from the kadhai",
  menu_title: "The Menu",
  step1_title: "Pick your dishes",
  step1_desc: "Browse the kadhai menu and add favourites to your cart.",
  step2_title: "Choose a slot 24 hrs ahead",
  step2_desc: "We cook fresh against every order, so delivery slots start at least 24 hours from now.",
  step3_title: "Pay & relax",
  step3_desc: "Secure PayU checkout. Hot food arrives at your Kalkaji doorstep in your slot.",
  footer_text: "Delivering only in Kalkaji, New Delhi · 110019",
};

export const CONTENT_FIELDS = [
  { key: "site_tagline", label: "Header tagline (under logo)" },
  { key: "header_pincode_badge", label: "Header pincode badge" },
  { key: "header_preorder_badge", label: "Header pre-order badge" },
  { key: "hero_badge", label: "Hero badge pill" },
  { key: "hero_title_1", label: "Hero heading — part 1" },
  { key: "hero_title_highlight", label: "Hero heading — highlighted word" },
  { key: "hero_title_2", label: "Hero heading — part 2" },
  { key: "hero_subtitle", label: "Hero paragraph", textarea: true },
  { key: "pincode_widget_title", label: "Pincode checker title" },
  { key: "pincode_widget_text", label: "Pincode checker text", textarea: true },
  { key: "menu_kicker", label: "Menu section kicker" },
  { key: "menu_title", label: "Menu section title" },
  { key: "step1_title", label: "How it works — step 1 title" },
  { key: "step1_desc", label: "Step 1 description", textarea: true },
  { key: "step2_title", label: "How it works — step 2 title" },
  { key: "step2_desc", label: "Step 2 description", textarea: true },
  { key: "step3_title", label: "How it works — step 3 title" },
  { key: "step3_desc", label: "Step 3 description", textarea: true },
  { key: "footer_text", label: "Footer text" },
];
